
import React, { createContext, useContext, useState, useEffect } from 'react';
import useApi from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const { get } = useApi();
  const { user } = useAuth();
  const [settings, setSettings] = useState({
    user_roles: ['Clerk', 'Officer', 'Admin', 'SuperAdmin'],
    dispatch_priorities: ['Normal', 'Urgent', 'Most Urgent'],
    dispatch_modes: ['Post', 'Email', 'Hand Delivery', 'Courier', 'Fax', 'Speed Post'],
    dispatch_statuses: ['Draft', 'Dispatched', 'Delivered', 'Returned'],
    dispatch_categories: ['General', 'Finance', 'Legal', 'HR', 'Confidential'],
    receipt_priorities: ['Normal', 'Urgent', 'Most Urgent'],
    receipt_modes: ['Post', 'Email', 'Hand Delivery', 'Courier', 'Fax'],
    receipt_document_types: ['Letter', 'Noting', 'Email', 'Fax'],
    receipt_statuses: ['In Progress', 'Completed', 'Closed'],
    receipt_categories: ['General', 'Finance', 'Legal', 'HR', 'Confidential'],
    contact_categories: ['Government', 'Vendor', 'Citizen', 'Internal Organization'],
    dispatch_number_scheme: 'auto',
    dispatch_number_format: 'WAPDA/DISP/{YYYY}/{SEQ}',
    receipt_number_scheme: 'auto',
    receipt_number_format: 'WAPDA/RCPT/{YYYY}/{SEQ}',
    efile_enabled: 0,
    efile_number_scheme: 'auto',
    efile_number_format: 'WAPDA/FILE/{YYYY}/{SEQ}',
    role_page_access: null,
    role_permissions: null,
    my_permissions: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchSettings();
    } else {
      setLoading(false);
    }
  }, [user]);

  const fetchSettings = async () => {
    try {
      const response = await get('/settings');
      if (response.data) {
        setSettings(prev => ({ ...prev, ...response.data }));
      }
    } catch (error) {
      console.error('Failed to fetch settings:', error);
      // Don't show toast on initial load error to avoid annoyance, just fallback to defaults
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};
